export const defaultAvatarFor = [
    // "men", 
    // "women",
    "lego"
]
export const avatarRight = `https://randomuser.me/api/portraits/${defaultAvatarFor[Math.floor(Math.random()*defaultAvatarFor.length)]}/${Math.floor(Math.random()*9)+1}.jpg`;
export const avatarLeft = `https://randomuser.me/api/portraits/${defaultAvatarFor[Math.floor(Math.random()*defaultAvatarFor.length)]}/${Math.floor(Math.random()*9)+1}.jpg`;
export const STREAM_CHAT_API_KEY = "j2g9djcczjsf";
export const SEND_BIRD_API_KEY = "B2439D11-63C2-4588-BED7-A13C714F2EBC";
export const COMET_CHAT_API_KEY = "fb45ea43c11a150b643960658dfc9b13075e0ad0"
export const COMET_CHAT_APP_REGION = "EU"
export const COMET_CHAT_AUTH_KEY = "95d4aeaa3194b8efd5d0d4eff08ff1853395efe8"
export const COMET_CHAT_APP_ID = "253653bd58f4162e"